import React, { Component, useEffect, useMemo, useState } from 'react';
import { getWebAbsPath } from '../util/path';
function TeethPosition({ teeth, side, disabled = false, selectedTooth, setSelectedTooth, checkSuccess = false, height = 300, scale = 1 }) {
const handleSelectTeeth = (value) => {
        if (selectedTooth.length === 0) {
            setSelectedTooth([value]);
            return;
        }
        const found = selectedTooth.find((v) => v === value);
        if (found === undefined) {
            setSelectedTooth([...selectedTooth, value]);
            return;
        }
        setSelectedTooth(selectedTooth.filter((v) => v !== value));
    };

    const handleClick = (e) => {
        const { left, top } = e.currentTarget.getBoundingClientRect();
        const x = (e.clientX - left) / scale;
        const y = (e.clientY - top) / scale;

        for (let [_, objValue] of Object.entries(teeth)) {
            if (x > objValue.maxX || x < objValue.minX || y > objValue.maxY || y < objValue.minY) continue;
            for (let i = 0; i < objValue.values.length; i++) {
                const { value, boundX } = objValue.values[i];
                if (boundX < x) continue;
                handleSelectTeeth(value);
                break;
            }
            break;
        }
    };

    return (
        <div
            style={{ width: `${1175 * scale}px`, height: `${height * scale}px` }}
            // tabIndex="0"
        >
            <div
                style={{
                    width: 1175,
                    height,
                    transform: `scale(${scale})`,
                    transformOrigin: 'top left',
                    // 'margin-top': "10px",
                    position: 'relative',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url("${getWebAbsPath(side == 'Top' ? '/img/prescriptionNotes/top_teeth_number_CS6.ai.png' : '/img/prescriptionNotes/bottom_teeth_number_CS6.ai.png')}")`,
                    // backgroundColor: props.attachments.value === "includedExcludedAttachments" && props.attachments.doNotPlace.length === 0 && props.prescriptionError && props.prescriptionErrorQuestion === 1 ? '#faff78' : null
                    cursor: disabled ? 'not-allowed' : 'default',
                }}
                onClick={(e) => {
                    // if (props.readOnly) return
                    // if (!this.validation("attachments")) return
                    if (disabled) return;
                    handleClick(e);
                }}
            >
                {selectedTooth.map((toothValue) => {
                    for (let [_, objValue] of Object.entries(teeth)) {
                        for (let { value, positionX, positionY } of objValue.values) {
                            if (value === toothValue) {
                                return (
                                    <img
                                        key={value}
                                        src={getWebAbsPath(
                                            checkSuccess
                                                ? '/img/prescriptionNotes/checkSuccess.png'
                                                : '/img/prescriptionNotes/checkFail.png'
                                        )}
                                        alt="checked"
                                        style={{
                                            position: 'absolute',
                                            top: positionY - 10,
                                            left: positionX - 12,
                                            userSelect: 'none',
                                        }}
                                    />
                                );
                            }
                        }
                    }
                })}
            </div>
        </div>
    );
}

export default TeethPosition;
